var Mode = Object.freeze({
  NAVIGATION: 'navigation',
  ACTIONABLE: 'actionable'
});
export default Mode;
//# sourceMappingURL=mode.js.map